export interface ContexteNav {
  contexte: string;
  retourHref: string;
  retourLabel: string;
}

export interface ContexteNavLu {
  contexte?: string;
  retourHref?: string;
  retourLabel?: string;
}

/* Un mini-app ouvert depuis un contexte (classe, élève, devoir) déjà affiché
   ailleurs ne doit pas réafficher un bandeau générique déconnecté : ces trois
   paramètres, ajoutés à l'URL de la mini-app cible, lui permettent de montrer
   d'où on vient (fil d'ariane) et d'y revenir (backTo). Absents, la mini-app
   retombe sur son bandeau générique — cas de l'ouverture directe depuis
   /mini-apps, sans contexte amont. */
export function avecContexteNav(href: string, ctx: ContexteNav): string {
  const params = new URLSearchParams({
    contexte: ctx.contexte,
    retourHref: ctx.retourHref,
    retourLabel: ctx.retourLabel,
  });
  return `${href}${href.includes('?') ? '&' : '?'}${params.toString()}`;
}

export function lireContexteNav(params: URLSearchParams): ContexteNavLu {
  return {
    contexte: params.get('contexte') ?? undefined,
    retourHref: params.get('retourHref') ?? undefined,
    retourLabel: params.get('retourLabel') ?? undefined,
  };
}
